import type { Element } from 'slate';

function emptyParagraph(): Element {
  return {
    type: 'paragraph',
    children: [
      {
        text: '',
      },
    ],
  };
}

export default emptyParagraph;
